goog.provide('el8.tourguide.Splash');

goog.require('el8.app.pageLayout');

/**
 * This widget overlays a single, explanatory dialog on the page.
 * It is primary used to explain something general about a page (as opposed
 * to the InfoSplash widget, which is more useful for explaining layout).
 *
 * To see an example, check out supportGuideSplash.js
 */
el8.tourguide.Splash = function(opts) {
    opts = opts || {};
    this._opacity = (opts.opacity === null || opts.opacity === undefined) ?
        0.7 : opts.opacity;
    this._zIndex = (opts.zIndex === null || opts.zIndex === undefined) ?
        1 : opts.zIndex;
    this._contentFn = opts.contentFn || null;
    this._overlayContentFn = opts.overlayContentFn || null;
    this._clickTriggerMap = opts.clickTriggerMap || null;
    this._topOffset = opts.topOffset || 0;
    this._backgroundColor = opts.backgroundColor || 'white';
};

el8.tourguide.Splash.prototype.show = function(opts) {

    var windowHeight = '100%';
    var windowWidth = '100%';
    if (this._topOffset) {
        windowHeight = $(window).height() - (jQuery.isFunction(this._topOffset) ? this._topOffset() : this._topOffset);
    }

    this._overlay = $('<div class="tourGuideSplash">');
    this._overlay.css({
        'opacity': this._opacity,
        'height': windowHeight,
        'width': windowWidth,
        'position': 'fixed',
        'left': 0,
        'top': this._topOffset,
        'background-color': this._backgroundColor,
        'z-index': this._zIndex
    });
    if (this._overlayContentFn) { this._overlay.html(this._overlayContentFn()); }
    $('body').prepend(this._overlay);

    this._dialog = $('<div class="tourGuideSplashDialog">');
    if (this._contentFn) { this._dialog.html(this._contentFn()); }
    this._dialog.hide();
    $('body').prepend(this._dialog);
    this._dialog.fadeIn();
    this._positionDialog();

    var that = this;
    if (this._clickTriggerMap) {
        for (var t in this._clickTriggerMap) {
            if (this._clickTriggerMap.hasOwnProperty(t)) {
                $(this._dialog[0]).on('click', t, that._clickTriggerMap[t]);
            }
        }
    }

    this._keydownFn = function(e) {
        if (e.keyCode === KEYS.ESC) {
            e.preventDefault();
            that.hide();
        }
    };
    $(document).on('keydown', this._keydownFn);

    /* Add resize listener on dialog */
    that._resizeFn = function() { that._positionDialog(); };
    el8.app.pageLayout.addResizeListener(that._resizeFn);
};

el8.tourguide.Splash.prototype._positionDialog = function() {
    if (this._dialog) {
        var idealTop = (el8.app.pageLayout.getAppInnerHeight() - (this._dialog.outerHeight(true) || 0)) / 2;
        this._dialog.css({
            'top': Math.max(el8.app.pageLayout.getAppHeaderHeight(), idealTop), // idealTop may be negative or too small
            'left': (el8.app.pageLayout.getAppWidth()-this._dialog.outerWidth(true))/2
        });
    }
};

el8.tourguide.Splash.prototype.hide = function() {
    if (this._overlay) { this._overlay.remove(); }
    var that = this;
    if (this._dialog) {
        this._dialog.remove();
    }
    if (this._resizeFn) {
        el8.app.pageLayout.removeResizeListener(this._resizeFn);
    }
    $(document).unbind('keydown', this._keydownFn);
};

el8.tourguide.Splash.prototype.getOverlay = function() {
    return this._overlay;
};

el8.tourguide.Splash.prototype.setContent = function(html) {
    this._dialog.html(html); // XSS OK -RS (input should come from a template)
};
